const BILLNUMBER_API_REQUEST = "BILNUMBER/BILNUMBER_API_REQUEST";
const BILLNUMBER_API_SUCCESS = "BILNUMBER/BILNUMBER_API_SUCCESS";
const BILLNUMBER_API_FAILED = "BILNUMBER/BILNUMBER_API_FAILED";

export { BILLNUMBER_API_REQUEST, BILLNUMBER_API_SUCCESS, BILLNUMBER_API_FAILED }